/**
 * Age gate — cookie-based verification.
 * Loaded non-deferred (before DOMContentLoaded) to prevent page flash.
 * Sets cookie: fb_age_verified=true; 30 days; SameSite=Strict
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'fb_age_verified';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days in seconds

  function getCookie(name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().startsWith(name + '=');
    });
  }

  function setCookie(name, value, maxAge) {
    document.cookie =
      name + '=' + value + '; max-age=' + maxAge + '; path=/; SameSite=Strict';
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function trapFocus(container) {
    var focusable = getFocusableElements(container);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    first.focus();
  }

  function showGate(gate) {
    gate.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    var modal = gate.querySelector('.age-gate__modal');
    if (modal) trapFocus(modal);
  }

  function hideGate(gate) {
    gate.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function init() {
    if (getCookie(COOKIE_NAME)) return;

    var gate = document.getElementById('age-gate');
    if (!gate) return;

    showGate(gate);

    var yesBtn = document.getElementById('age-gate-yes');
    var noBtn = document.getElementById('age-gate-no');

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        setCookie(COOKIE_NAME, 'true', COOKIE_MAX_AGE);
        hideGate(gate);
      });
    }

    if (noBtn) {
      noBtn.addEventListener('click', function () {
        window.location.href = 'https://www.google.com';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
